import { Lock, Smartphone } from 'lucide-react';
import { Tooltip } from '@/shared/ui/tooltip';

/** Selo do filtro base (método de disparo = push): sempre aplicado, sem como remover. */
export function SegmentationPushBaseFilter() {
  return (
    <Tooltip
      content="Toda segmentação é para disparo por push: só entram leads com push disponível. Esse filtro é aplicado sempre — na contagem, na amostra, no público salvo e no assistente de IA — e não pode ser removido."
      className="max-w-xs"
    >
      <div
        className="glass-elevated flex items-center gap-2 rounded-full px-3 py-1.5 text-xs shadow-glass-sm"
        role="note"
        aria-label="Filtro base fixo: método de disparo igual a push"
      >
        <Lock className="size-3.5 shrink-0 text-muted-foreground" aria-hidden />
        <span className="text-muted-foreground">
          <span className="hidden sm:inline">Filtro base · </span>Método de disparo
        </span>
        <span className="inline-flex items-center gap-1 rounded-full bg-primary/12 px-2 py-0.5 font-medium text-primary">
          <Smartphone className="size-3" aria-hidden />
          Push
        </span>
      </div>
    </Tooltip>
  );
}
